import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseProvider } from '../BaseProvider';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class AuditService extends BaseProvider {

    getAuditTrailUrl = 'auditTrails?orderId=##orderId##';

    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
    }

    public getAuditTrails(orderId: string) {
        let url: string = this.getAuditTrailUrl.replace('##orderId##', orderId);
        return this.makeGetCall(url);
    }
    public getConsumerAuditTrails(consumerId) {
        return this.makeGetCall("consumerAuditTrails?consumerId=" + consumerId);
    }
    public getRemitAuditTrails(orderId) {
        return this.makeGetCall("remitAuditTrails?orderId=" + orderId);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/audit/audit.service.ts